import { AxiosResponse } from "axios";
import { authRequest } from "common/src/utils/request";

/**
 * API0520 Web証券PDF出力
 * @returns
 */
export const getInsurancePolicy = async (): Promise<AxiosResponse<File>> => {
  return await authRequest.get("/v1/mypage/insurancePolicy", { responseType: "blob" });
};
